<template>
    <div>
        <div class="form-group">
            <button class="btn btn-primary" @click="triggerFileInput">
                + Upload Images
            </button>
            <input
                ref="fileInput"
                type="file"
                multiple
                accept="image/*"
                @change="handleFileUpload"
                class="d-none"
            />
        </div>
        <div class="row mt-4 container">
            <draggable v-model="images" class="row w-100" :options="{ animation: 200 }">
                <div
                    v-for="(image, index) in images"
                    :key="image.id"
                    class="col-md-3 col-sm-4 col-6 mb-4"
                >
                    <div class="card h-100 position-relative shadow-sm">
                        <button
                            type="button"
                            class="btn btn-sm btn-danger position-absolute top-0 end-0 m-1"
                            @click="removeImage(image)"
                            aria-label="Close"
                        >
                            &times;
                        </button>

                        <img :src="image.imageUrl" class="card-img-top" alt="Preview" />
                    </div>
                </div>
            </draggable>
        </div>
    </div>
</template>

<script>
import axios from '@axios'
import draggable from "vuedraggable";
import router from '@/router'

export default {
    components: {
        draggable,
    },
    data() {
        return {
            images: [],
        };
    },
    methods: {
        triggerFileInput() {
            this.$refs.fileInput.click();
        },
        async handleFileUpload(event) {
            const files = Array.from(event.target.files);

            const userStorage = JSON.parse(localStorage.getItem("userData"));
            const placeId = router.currentRoute.params.id;

            const setData = {
                created_by: userStorage.id,
                updated_by: userStorage.id,
                place_id: placeId,
            };

            const formData = new FormData();
            formData.append("data", JSON.stringify(setData));

            for (const file of files) {
                const tempId = Date.now() + Math.random();
                const reader = new FileReader();

                reader.onload = (e) => {
                    this.images.push({
                        id: tempId,
                        file: file,
                        url: e.target.result,
                        uploading: true,
                    });
                };
                reader.readAsDataURL(file);

                formData.append("images", file);
            }

            try {
                await axios.post("/place/v1/facility/uploadImage", formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                });

                this.fetchFacilityImages();
            } catch (err) {
                this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                        title: "Error",
                        icon: "BellIcon",
                        variant: "danger",
                        text: err.response?.data?.message || "Failed to upload image(s).",
                    },
                });
            }

            event.target.value = null;
        },
        async removeImage(item) {
            try {
                const response = await axios.delete(`/place/v1/facility/deleteImage/${item.id}`);

                if (response.data.success) {
                    this.fetchFacilityImages()
                }
            } catch (error) {
                this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                        title: 'Error',
                        icon: 'AlertCircleIcon',
                        variant: 'danger',
                        text: error.response?.data?.message || 'Failed to remove images.',
                    },
                });
            }
        },
        async fetchFacilityImages() {
            const placeId = router.currentRoute.params.id;

            try {
                const response = await axios.get(`/place/v1/facility/getImages/${placeId}`);

                if (response.data.success) {
                    this.images = response.data.data;
                }
            } catch (error) {
                this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                        title: 'Error',
                        icon: 'AlertCircleIcon',
                        variant: 'danger',
                        text: error.response?.data?.message || 'Failed to fetch images.',
                    },
                });
            }
        },
    },
    created() {
        this.fetchFacilityImages()
    }
};
</script>

<style scoped>
.card-img-top {
  height: 200px;
  object-fit: cover;
}

button[aria-label="Close"] {
  font-size: 1.2rem;
  line-height: 1;
  border: none;
}
</style>